export enum TypeEventDocument {
  RG = 'rg',
  CPF = 'cpf',
  FOTO_3X4 = 'foto 3x4',
  CERTIDAO_CASAMENTO = 'certidão de casamento',
  COMPROVANTE_ENDERECO = 'comprovante de endereço',
  CARTA_ESPOSA = 'carta da esposa',
  XEROX_DIPLOMA_TEOLOGIA = 'xerox do diploma de teologia',
  ATESTADOS_ANTECEDENTES_CRIMINAIS = 'atestados de antecedentes criminais',
  CERTIDAO_PROTESTO_CIDADE = 'certidão do cartório de protesto da cidade',
}

export enum TypeSide {
  BACK = 'BACK',
  FRONT = 'FRONT',
}

export enum DocumentApprovalStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  IN_REVIEW = 'In Review',
}
